import { FC } from 'react';
import { getLogoUrl, replaceHtmlToStr } from 'utils/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faPlane } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import { dateFormat } from 'utils/ui';
import { FlightOutBound } from 'ts/package/interfaces/PackageOfflineResponse';
import { onImageLoadError } from 'utils/package';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { blobUrl } from 'constants/generic';

interface TicketDetailsProps {
  type: string;
  bound: FlightOutBound;
  remarks: string;
}

const TicketDetails: FC<TicketDetailsProps> = ({ bound, type, remarks }) => {
  const [t] = useTranslation();

  const depDateTime = `${bound.date}T${bound.depTime}`;
  const arrDateTime = `${bound.date}T${bound.arrTime}`;

  return (
    <div className="default-shadow flight-details-item flight-details-ticket package-ticket">
      <div className={'ticket-header' + (type === 'departure' ? ' ticket-header-forward' : '')}>
        <FontAwesomeIcon className="text-sm mr-5 text-contrast" icon={faPlane} />{' '}
        {t(type === 'return' ? 'flight.return' : 'flight.departure')}
      </div>
      <div className="ticket-details-info">
        <div className="item">
          <span className="city text-bold">{bound.departureIATA}</span>
          <span className="time text-bold">{dateFormat(depDateTime, 'HH:MM')}</span>
          <span className="day">{dateFormat(depDateTime, 'EEE - dd MMMM, yyyy')}</span>
        </div>
        <div className="item">
          <span className="city text-bold">{bound.arrivalIATA}</span>
          <span className="time text-bold">{dateFormat(arrDateTime, 'HH:MM')}</span>
          <span className="day">{dateFormat(arrDateTime, 'EEE - dd MMMM, yyyy')}</span>
        </div>
        <div className="item flex-center">
          <span className="flex-center">
            <img
              src={getLogoUrl(blobUrl, bound.airline)}
              alt={bound.airline}
              onError={(e) => onImageLoadError(e, undefined)}
            />
            <span className="ticket-airline-code text-xxs">
              {bound.airline} {bound.flightNumber}
            </span>
          </span>
        </div>
        <div className="item">
          <Tooltip children={<FontAwesomeIcon icon={faClock} />} content={t('filter.duration')} />
          <span className="time text-bold">{bound.flightDuration}</span>
        </div>
      </div>
      <div className="text-sm">
        <span className="text-contrast">{t('notes')}: </span>
        <span dangerouslySetInnerHTML={{ __html: replaceHtmlToStr(remarks) }}></span>
      </div>
    </div>
  );
};

export default withErrorBoundary(TicketDetails, 'TicketDetails');
